module.exports = __webpack_public_path__ + "static/media/contact-slide-6.c1f3d905.jpg";